module.exports = __webpack_public_path__ + "img/Image - Header 5(2).9b4bccfe.png";